var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"swiper-container",attrs:{"dir":_vm.direction}},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"swiper-pagination"})])
}
var staticRenderFns = []

export { render, staticRenderFns }